import { ArtifactsList } from '@/components/artifacts/ArtifactsList';
import { PageContainer } from '@startupquickstart/frontend';

const breadcrumbs = [
  { label: 'Home', href: '/' },
  { label: 'Artifact Library', current: true },
];

export function ArtifactsPage() {
  return (
    <PageContainer>
      <ArtifactsList breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
